// i18next-extract-mark-ns-start menu
// cSpell:ignore tilly, tili

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Link } from '../../services/link';
import withAppContext from '../../withAppContext';
import withCustomerContext from '../../withCustomerContext';
import withOrderContext from '../../withOrderContext';
import routesMap from '../../Routes';
import { removeToken } from '../../services/api';
import DropdownList from './DropdownList';
import MobileMenu from './v3/MobileMenu';
import {
  colors, fontSizes, tabletThresholdPixels, mobileThresholdPixels,
  menuBarHeightPixels, mobileMenuBarHeightPixels, menuBarHeightWithBannerPixels, mobileMenuBarHeightWithBannerPixels,
  tabletMenuBarHeightWithBannerPixels, tabletMenuBarHeightPixels,
} from './v4/styledComponents';
import { Row } from './v3/styledComponents';
import PopupTemporaryPassword from '../MyAccount/PopupTemporaryPassword';

import dropdownArrow from '../../assets/arrow-dropdown-list-light.svg';
import logoTilli from '../../assets/logos/tilli.black.svg';
import menuIcon from '../../assets/menu.svg';
import closeIcon from '../../assets/menuClose.svg';
import CTALink from '../CTALink';
import { getAboutList, getServicesList } from './menuData';
import loginIcon from '../../assets/login.icon.svg';
import LanguagesSwitcher from './LanguagesSwitcher';
import { urlsToHideForLanding } from '../../services/setOfUrl';

const BarContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: ${({ hasBanner }) => hasBanner ? menuBarHeightWithBannerPixels : menuBarHeightPixels};
  background-color: ${(props) => (props.scrolled ? `${colors.beige100}` : 'transparent')};
  background-color: ${({ homePage }) => !homePage && colors.beige100};
  transition: background-color 0.3s ease, color 0.3s ease;
  transform: ${({ hide }) => hide ? 'translateY(-100%)' : 'translateY(0)'};
  z-index: 3;

  @media (max-width: ${tabletThresholdPixels}) {
    height: ${({ hasBanner }) => hasBanner ? tabletMenuBarHeightWithBannerPixels : tabletMenuBarHeightPixels};
    border-bottom-width: 0px;
  }
  @media (max-width: ${mobileThresholdPixels}) {
    height: ${({ hasBanner }) => hasBanner ? mobileMenuBarHeightWithBannerPixels : mobileMenuBarHeightPixels};
  }
`;

const DesktopMenu = styled.div`
  display: block;
  @media (max-width: ${mobileThresholdPixels}) {
    display: none;
  }
`;

const MobileMenuBar = styled.div`
  display: none;
  @media (max-width: ${mobileThresholdPixels}) {
    display: block;
    width: 100%;
  }
`;

const Content = styled.div`
  width: 1300px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${menuBarHeightPixels};
  @media (max-width: 1350px) {
    width: 1150px;
  }
  @media (max-width: ${tabletThresholdPixels}) {
    width: 100%;
    gap: 30px;
  }
`;

const StyledRow = styled(Row)`
  width: 100%;
  padding: 0px 23px;
  box-sizing: border-box;
  align-items: center;
  display: flex;
  justify-content: space-between;
  height: ${menuBarHeightPixels};
  position: relative;
  @media (max-width: ${tabletThresholdPixels}) {
    height: ${mobileMenuBarHeightPixels};
  }
`;

const LinkContainer = styled.div`
  text-align: center;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  ${(props) => props.gap && 'gap: 20px;'}
  ${(props) => props.fixWidth && 'width: 88px; justify-content: flex-end;'}

  @media (max-width: ${tabletThresholdPixels}) {
    ${(props) => props.fixWidth && 'width: 50px; justify-content: flex-end;'}
  }
  @media (max-width: ${mobileThresholdPixels}) {
    ${(props) => props.logo && 'margin: 0px;'}
    margin-top: 0px;
  }
`;
const BlocksContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
  height: 100%;
`;

const BlockContainer = styled.div`
  display: flex;
  gap: 48px;
  @media (max-width: ${tabletThresholdPixels}) {
    gap: 20px;
  }
`;

const TextLink = styled.div`
  width: max-content;
  ${(props) => props.invert ? `color: ${colors.white};` : `color: ${colors.black};`}
  ${(props) => props.invert && `background-color: ${colors.black}; padding: 16px; border-radius: 4px`}
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.5px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 4px;
  ${(props) => props.invert ? 'height: unset; align-self: center;' : 'height: 100%;'}
  display: flex;
  align-items: center;

  &:hover {
    color: ${colors.grey400};
    text-decoration: underline;
  }

  @media (max-width: ${tabletThresholdPixels}) {
    ${(props) => props.invert && `background-color: ${colors.black}; padding: 14px; border-radius: 4px`}
  }

  @media (max-width: ${mobileThresholdPixels}) {
    color: ${colors.black};
    font-size: ${fontSizes.s};
    text-align: center;
    &:hover {
      opacity: 1;
    }
  }
`;

const Icon = styled.img``;

const LogoImg = styled.img`
  width: 168px;
  height: 19px;
  @media (max-width: ${tabletThresholdPixels}) {
    width: 120px;
    height: 13px;
  }
`;

const MenuIcon = styled.img`
  width: 22px;
`;

const Chevron = styled.img`
  margin-left: 8px;
  width: 8px;
  ${(props) => props.rotate && 'transform: rotate(180deg)'};
`;

const StyledLink = styled(Link)`
  flex: 1;
  text-align: center;
  text-decoration: none;
`;

const ItemContainer = styled.div`
  height: 100%;
`;

const renderLogo = (t) => (
  <LinkContainer logo>
    <StyledLink to={routesMap.HomePage.url}>
      <TextLink>
        <LogoImg src={logoTilli} alt={t('Logo du service de couturière Tilli')} />
      </TextLink>
    </StyledLink>
  </LinkContainer>
);

const renderCTA = (t) => (
  <LinkContainer>
    <CTALink fromInteraction="MenuBar">
      <TextLink invert>{t('Prendre soin ici')}</TextLink>
    </CTALink>
  </LinkContainer>
);

const MenuBar = ({ ...props }) => {
  const [currentPath, setCurrentPath] = useState('');
  const [hideMenu, setHideMenu] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrolled, setScrolled] = useState(false);

  const [displayServicesList, setDisplayServicesList] = useState(false);
  const [displayJoinUsList, setDisplayJoinUsList] = useState(false);
  const [displayMyAccountList, setDisplayMyAccountList] = useState(false);
  const [displayMobileMenuList, setDisplayMobileMenuList] = useState(false);
  const [isLoginPopupOpened, setIsLoginPopupOpened] = useState(props.isLoginPopupOpened);

  const {
    context: { isMobile },
    customerContext: { customer },
    homePage,
  } = props;

  const { t } = useTranslation();

  /**
  * 📜 Effect 1: Detect scroll to set scrolled state
  * Sets `scrolled` to true if the user has scrolled more than 150px
  */
  useEffect(() => {
    const scrollingHeight = isMobile ? 140 : 210;
    const handleScroll = () => setScrolled(window.scrollY > scrollingHeight);
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  /**
  * 📜 Effect 2: Set current path and hide menu for specific paths
  * Runs on mount and updates if the URL changes (via popstate or direct load)
  */
  useEffect(() => {
    const updatePathAndMenu = () => {
      const path = window.location.pathname;
      setCurrentPath(path);
      setHideMenu(urlsToHideForLanding.some((pattern) => path.includes(pattern)));
    };

    updatePathAndMenu();
    window.addEventListener('popstate', updatePathAndMenu);

    return () => {
      window.removeEventListener('popstate', updatePathAndMenu);
    };
  }, []);

  /**
  * 📜 Effect 3: Control hide/show menu on scroll
  * Checks if the scroll position has changed (up or down) and hides/shows the menu accordingly.
  */
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (urlsToHideForLanding.some((pattern) => currentPath.includes(pattern))) {
        if (currentScrollY > lastScrollY) {
          setHideMenu(false);
        } else if (currentScrollY < lastScrollY && currentScrollY > 0) {
          setHideMenu(true);
        }
      } else {
        setHideMenu(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [currentPath, lastScrollY]);

  /**
  * 📜 Effect 4: Synchronize `isLoginPopupOpened` with props
  * Ensures that the local state `isLoginPopupOpened` reflects the prop `props.isLoginPopupOpened`
  */
  useEffect(() => {
    setIsLoginPopupOpened(props.isLoginPopupOpened);
  }, [props.isLoginPopupOpened]);
  const getMyAccountList = () => ([
    { text: t('Récapitulatif'), url: routesMap.MyAccount.url },
    { text: t('Mes informations'), url: routesMap.MyInfos.url },
    { text: t('Mes adresses & paiements'), url: routesMap.MyAddressesAndPayments.url },
    {
      text: t('Mes commandes'),
      url: routesMap.MyOrders.url,
      onClick: () => {
        setDisplayMyAccountList(false);
        props.customerContext.setSelectedOrder(undefined);
      },
    },
    { text: t('Mes messages'), url: routesMap.MyMessages.url },
    {
      text: t('Déconnexion'),
      url: routesMap.HomePage.url,
      onClick: () => {
        props.customerContext.initializeCustomerContext();
        removeToken();
      },
    },
  ]);

  const toggleMobileMenuList = () => {
    setDisplayMobileMenuList(!displayMobileMenuList);
  };

  const renderServicesList = () => (
    <LinkContainer
      onMouseEnter={() => setDisplayServicesList(true)}
      onMouseLeave={() => setDisplayServicesList(false)}
    >
      <ItemContainer>
        <DropdownList isDisplayed={displayServicesList} dropdownList={getServicesList(t)} />
        <TextLink>
          {t('Nos services')}
          <Chevron
            src={dropdownArrow}
            rotate={displayServicesList ? 'true' : undefined}
            alt={t('Menu déroulant')}
          />
        </TextLink>
      </ItemContainer>
    </LinkContainer>
  );

  const renderAbout = () => (
    <LinkContainer
      onMouseEnter={() => setDisplayJoinUsList(true)}
      onMouseLeave={() => setDisplayJoinUsList(false)}
    >
      <ItemContainer>
        <DropdownList isDisplayed={!!displayJoinUsList} dropdownList={getAboutList(t)} />
        <TextLink>
          {t('À propos')}
          <Chevron
            src={dropdownArrow}
            rotate={displayJoinUsList ? 'true' : undefined}
            alt={t('Menu déroulant à propos')}
          />
        </TextLink>
      </ItemContainer>
    </LinkContainer>
  );

  const renderBecomePartner = () => (
    <LinkContainer>
      <StyledLink to={routesMap.WhyBecomePartner.url}>
        <TextLink>{t('Marque')}</TextLink>
      </StyledLink>
    </LinkContainer>
  );

  const renderBecomeTilliste = () => (
    <LinkContainer>
      <StyledLink to={routesMap.BeTillistePage.url}>
        <TextLink>{t('Artisan')}</TextLink>
      </StyledLink>
    </LinkContainer>
  );

  const renderMyAccountList = () => {
    if (!customer || customer.isShadowAccount) {
      return (
        <LinkContainer fixWidth={!isMobile}>
          <TextLink onClick={() => setIsLoginPopupOpened(true)}><Icon data-cy="login" src={loginIcon} alt={t('icône connexion')} /></TextLink>
        </LinkContainer>
      );
    }
    return (
      <LinkContainer
        fixWidth={!isMobile}
        onMouseEnter={() => setDisplayMyAccountList(true)}
        onMouseLeave={() => setDisplayMyAccountList(false)}
      >
        <ItemContainer>
          <DropdownList
            isDisplayed={!!displayMyAccountList}
            dropdownList={getMyAccountList()}
            right
          />
          <TextLink noMobilePaddingTop>
            <Icon src={loginIcon} alt={t('icône connexion')} />
            {!isMobile
            && (
              <Chevron
                src={dropdownArrow}
                rotate={displayMyAccountList ? 'true' : undefined}
                alt={t('Menu déroulant')}
              />
            )}
          </TextLink>
        </ItemContainer>
      </LinkContainer>
    );
  };

  const renderDesktop = () => (
    <Content>
      {renderLogo(t)}
      <BlocksContainer>
        <BlockContainer>
          {renderServicesList()}
          {renderBecomePartner()}
          {renderBecomeTilliste()}
          {renderAbout()}
          {renderCTA(t)}
        </BlockContainer>
        <BlockContainer>
          {renderMyAccountList()}
          <LanguagesSwitcher />
        </BlockContainer>
      </BlocksContainer>
    </Content>
  );

  const renderMobile = () => (
    <StyledRow justifyContent="flex-start">
      <LinkContainer>
        <StyledLink to={routesMap.HomePage.url}>
          <TextLink noMobilePaddingTop>
            <LogoImg src={logoTilli} alt={t('Logo du service de couturière Tilli')} />
          </TextLink>
        </StyledLink>
      </LinkContainer>
      <LinkContainer gap>
        <TextLink onMouseDown={() => toggleMobileMenuList()} noMobilePaddingTop noTabletPaddingRight>
          <MenuIcon
            alt={t('Tilli couturière Paris')}
            src={displayMobileMenuList ? closeIcon : menuIcon}
          />
        </TextLink>
        {renderMyAccountList()}
        <LanguagesSwitcher />
      </LinkContainer>
    </StyledRow>
  );

  return (
    <div>
      <BarContainer
        scrolled={scrolled}
        homePage={homePage}
        hide={hideMenu}
        displayMobileMenuList={displayMobileMenuList}
      >
        <DesktopMenu>{renderDesktop()}</DesktopMenu>
        <MobileMenuBar>{renderMobile()}</MobileMenuBar>
      </BarContainer>
      {isMobile && displayMobileMenuList
          && (
            <MobileMenu
              openLoginPopup={() => setIsLoginPopupOpened(true)}
              onClick={() => toggleMobileMenuList()}
              isCustomerLoggedIn={!!customer}
              close={() => setDisplayMobileMenuList(false)}
            />
          )}
      {isLoginPopupOpened
          && (
            <div>
              <PopupTemporaryPassword closePopup={() => setIsLoginPopupOpened(false)} />
            </div>
          )}
    </div>
  );
};

MenuBar.propTypes = {
  context: PropTypes.shape({
    isMobile: PropTypes.bool,
  }).isRequired,
  customerContext: PropTypes.shape({
    customer: PropTypes.shape({
      isShadowAccount: PropTypes.bool,
    }),
    setSelectedOrder: PropTypes.func,
    initializeCustomerContext: PropTypes.func,
  }).isRequired,
  isLoginPopupOpened: PropTypes.bool,
  orderContext: PropTypes.shape({
    getOrderRouteAndEvent: PropTypes.func,
  }).isRequired,
  t: PropTypes.func.isRequired,
  hideOnUrls: PropTypes.arrayOf(PropTypes.string),
  homePage: PropTypes.bool,
};

MenuBar.defaultProps = {
  isLoginPopupOpened: false,
  hideOnUrls: [],
  homePage: false,
};

export default (withAppContext(withCustomerContext(withOrderContext(MenuBar))));
